export const T = {
  en_GB: {
    defaultTitle: "Embedded web page",
    invalidUrl: "Invalid web page URL — an absolute https:// address is required",
    appOrigin: "This URL points to the app itself and cannot be shown here",
  },
  nb_NO: {
    defaultTitle: "Innebygd nettside",
    invalidUrl: "Ugyldig nettside-URL – en absolutt https://-adresse kreves",
    appOrigin: "Denne adressen peker til selve appen og kan ikke vises her",
  },
} as const;
